/// <reference path="../../../../app.definition.ts" />

import angular from "angular";
import { Discussion } from "@common/model/discussion";
import { User } from "@common/model/user";
import { IConfigService } from "@common/service/config.service";
import { IUserService } from "@common/service/user.service";
import { CacheService } from "@common/service/cache.service";
import { DiscussionComment } from "@common/model/discussionComment";
import { IAppRootScopeService } from "@/app/app.definition";

export interface IEcvCommentBox {
    init(element: any): void;
    isEmpty(): boolean;
    hasOne(): boolean;
    viewMoreComments(): void;
}

class EcvCommentBox implements IEcvCommentBox {
    commentCallback: Function;
    comment: {
        text: string;
    };
    loading: boolean;
    element: ng.IAugmentedJQuery;
    conf: {
        origLimit: number;
        limit: number;
        limitIncrement: number;
        comment: {
            length: number;
        };
    };
    post: Discussion;
    count: number;
    single: boolean;
    overLimit: boolean;
    currentUser: User;

    static $inject = [
        "$rootScope",
        "ConfigService",
        "UserService",
        "CacheService",
    ];

    constructor(
        private $rootScope: IAppRootScopeService,
        private $config: IConfigService,
        private $_user: IUserService,
        private $_cache: CacheService
    ) {
    }

    init(element: ng.IAugmentedJQuery): void {
        //console.log('EcvCommentBox: ', this.post);
        this.comment = { text: "" };
        this.loading = false;
        this.conf = this.$config.get("commentBox");
        this.conf.origLimit = this.conf.limit;
        this.element = element;
        // this.currentUser = this.$_user.getMe();
        this.currentUser = this.$_cache.getUser();
        this.count = this.post.commentsCount;
        this.single = this.count == 1;
        this.overLimit = this.count < this.conf.limit;
        //console.log(this.post.title || this.post.displayData, "Comment count:", this.post.commentsCount, "; Original Limit:", this.conf.origLimit, "; Limit:", this.conf.limit);
    }

    postHasDocument(): boolean {
        return (
            !!this.post &&
            ((!!this.post.filename &&
                this.post.filename != "" &&
                this.post.keywords != "status" &&
                this.post.documentType == "DOCUMENT") ||
                !!this.post.thumbnail ||
                (!!this.post.attachments &&
                    !!this.post.attachments[0] &&
                    !!this.post.attachments[0].filename))
        );
    }

    getLastComment(): DiscussionComment {
        if (!this.post.comments || !this.post.comments.length) return null;

        let maxId = Math.max.apply(
            Math,
            this.post.comments
                .filter(function (c) {
                    return c.commentType != "SYSTEM_DEFINED";
                })
                .map(function (o) {
                    return o.id;
                })
        );

        let lastestComment = this.post.comments.find(function (element) {
            return element.id == maxId;
        });

        if (lastestComment) {
            return lastestComment;
        } else {
            return null;
        }
    }

    showOnly = (): boolean => {
        return (
            this.limitOverOriginalLimit() ||
            (!this.countOverCurrentLimit() && !this.countOverOriginalLimit())
        );
    };

    showAll = (): boolean => {
        return;
    };

    moreOrLess = (): boolean => {
        return this.limitOverOriginalLimit() && this.countOverCurrentLimit();
    };

    limitOverOriginalLimit = (): boolean => {
        return this.conf.limit > this.conf.origLimit;
    };

    countOverOriginalLimit = (): boolean => {
        return this.post.commentsCount > this.conf.origLimit;
    };

    countOverCurrentLimit = (): boolean => {
        return this.post.commentsCount > this.conf.limit;
    };

    getDisplayTotal = () => {
        return this.post.commentsCount;
    };

    getDisplayCount = () => {
        return this.post.commentsCount == 1
            ? ""
            : this.conf.limit < this.post.commentsCount
                ? this.conf.limit
                : this.post.commentsCount;
    };

    isEmpty(): boolean {
        return !this.post.comments || this.post.commentsCount == 0;
    }

    hasOne(): boolean {
        return !!this.post.comments && this.post.commentsCount == 1;
    }

    viewMoreComments(): void {
        this.conf.limit += this.conf.limitIncrement;
    }

    viewAllComments(): void {
        this.conf.limit = this.post.commentsCount;
    }

    viewLessComments(): void {
        this.conf.limit = this.conf.origLimit;
    }

    toggleCommentBox(): void {
        let editor = document.getElementById("comment-editor-" + this.post.id);
        let commentBox = document.getElementById("comment-box-" + this.post.id);
        if (commentBox.style.display === "none") {
            commentBox.style.display = "block";
            editor.style.display = "none";
        } else {
            commentBox.style.display = "none";
            editor.style.display = "block";
            (this.element.find("div.ql-editor")[0] as HTMLElement).focus();
        }
    }

    cancel(): void {
        this.comment.text = "";
        this.toggleCommentBox();
    }

    addComment(): void {
        this.$rootScope.mainShowLoader = "Sending...";
        this.post.currentComment = this.comment.text;
        this.comment.text = "";
        this.toggleCommentBox();
        this.commentCallback(this.post);
    }
}

function export_func(): ng.IDirective {
    return {
        restrict: "E",
        scope: {
            post: "=ecvPostObject",
            commentCallback: "=?ecvCommentCallback",
            loadMoreCallback: "=?loadMoreCallback",
        },
        templateUrl:
            "app/common/itemCard/components/commentBox/commentBox.directive.html",
        replace: true,
        controller: EcvCommentBox,
        controllerAs: "commentBoxVm",
        bindToController: true,
        link: (
            scope: ng.IScope,
            element: ng.IAugmentedJQuery,
            attributes: ng.IAttributes,
            controller: IEcvCommentBox
        ): void => {
            controller.init(element);
        },
    };
}

angular
    .module("eCareVault.common.itemCard")
    .directive("ecvCommentBox", export_func);
